import {
  actions,
  addContentToFollowingsAsync,
  removeContentToFollowingsAsync,
  getFollowingsAsync,
} from './slices';

export const FollowingsActions = {
  ...actions,
  addContentToFollowingsAsync,
  removeContentToFollowingsAsync,
  getFollowingsAsync,
};

export * from './thunkHandlers';
